// extracted by mini-css-extract-plugin
export default {"root":"root--iSEFH","name":"name--k8ULU","draggable":"draggable--t3Zqj"};